import store from '@/store';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useClient } from '@/lib/_API/useClient';
import { computed } from 'vue';

export function useUserData() {
  const { getClientInfo, getClientUnitInfo } = useClient();

  const setupUserData = async () => {
    const { client, center, group, tos } = await getClientInfo();
    store.dispatch('mypage/updateClient', client);
    store.dispatch('mypage/updateCenter', center);
    store.dispatch('mypage/updateGroup', group);
    store.dispatch('mypage/updateMarketing', tos.marketing);

    const clientUnitInfo = await getClientUnitInfo();
    store.dispatch('mypage/updateUnit', clientUnitInfo);
  };

  return {
    setupUserData,
  };
}

type PendingGroup = {
  _id: string;
  groupName: string;
};
interface UserUnitPrivilege {
  unitAuth: 'none' | 'pending' | 'member' | 'groupHost' | 'unitAdmin';
  pendigGroups: PendingGroup[] | [];
  clientId?: string;
}

export function useComposition() {
  const store = useStore();

  /**
   * 유닛관리에 대한 권한
   */
  const userUnitPrivilege = computed<UserUnitPrivilege>(() => {
    if (!store || !store.state.mypage.unit)
      return {
        unitAuth: 'none',
        pendigGroups: [],
        clientId: '',
      };
    const { participantUnitId, unitRole, groupRoles, pendingGroups, clientId } = store.state.mypage
      .unit as api.client.getInfo.clientUnitInfo;

    const clientUnitInfo = {
      participantUnitId: participantUnitId,
      unitRole: unitRole,
      groupRoles: groupRoles,
      pendingGroups: pendingGroups,
    };
    let authAndPending: UserUnitPrivilege = {
      unitAuth: 'none',
      pendigGroups: [...clientUnitInfo.pendingGroups],
      clientId: clientId,
    };
    if (clientUnitInfo.participantUnitId === null) {
      authAndPending.unitAuth = clientUnitInfo.pendingGroups.length ? 'pending' : 'none';
    } else if (clientUnitInfo.unitRole === 'unitAdmin') {
      authAndPending.unitAuth = 'unitAdmin';
    } else if (clientUnitInfo.groupRoles.includes('host')) {
      authAndPending.unitAuth = 'groupHost';
    } else {
      authAndPending.unitAuth = 'member';
    }

    return authAndPending;
  });

  return { userUnitPrivilege };
}
